<template>
  <div class="block-news-year">
    <h2 class="year-heading">{{ year }}</h2>
    <div v-if="articles.length" class="articles-grid">
      <article v-for="a in articles" :key="a.id" class="article-item">
        <div class="article-meta">
          <time v-if="a.date" class="article-date">{{ formatDate(a.date) }}</time>
          <span v-if="a.category" class="article-category">{{ a.category }}</span>
        </div>
        <a :href="pathName(a.url)" class="article-title">{{ a.title }}</a>
      </article>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'

const props = defineProps(['block'])
const lang = document.documentElement.lang

const articles = ref([])
const year = computed(() => Number(props.block?.content?.year) || new Date().getFullYear())

function formatDate(str) {
  if (!str) return ''
  const d = new Date(str + 'T12:00:00')
  if (isNaN(d)) return str
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`
}

onMounted(async () => {
  const y = year.value
  const lc = (f) => lang ? `page.content("${lang}").${f}` : `page.content.${f}`
  const { data } = await axios.post('/api/cachedKQL', {
    select: {
      articles: {
        query: [
          'site.find("ajankohtaista").children.listed',
          `.filterBy("date", ">=", "${y}-01-01")`,
          `.filterBy("date", "<=", "${y}-12-31")`,
          '.sortBy("date", "desc")',
        ].join(''),
        select: {
          id: true,
          title: lc('title'),
          url: lang ? `page.url("${lang}")` : true,
          date: lc('date'),
          category: lc('category'),
        }
      }
    }
  })
  articles.value = cleanUpJSON(data.result?.articles || [])
})
</script>

<style scoped>
.block-news-year {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.year-heading {
  font-size: clamp(24px, 4vw, 48px);
  font-weight: 700;
  margin: 0;
  display: inline-block;
  border: 1px solid currentColor;
  padding: 0.25em 0.6em;
}

.articles-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

@media (max-width: 600px) {
  .articles-grid { grid-template-columns: 1fr; }
}

.article-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--fg-20, currentColor);
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  font-size: 0.85rem;
  opacity: 0.6;
}

.article-date {
  font-variant-numeric: tabular-nums;
}

.article-category {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.75rem;
}

.article-title {
  font-size: 1.1rem;
  line-height: 1.35;
  font-weight: 500;
}
</style>
